module.exports = __webpack_public_path__ + "img/HEART SHADES RED.41f12b9.svg";